import { useApi } from '../composables/useApi'
import { URLS } from '../constants/urls'

export function fundacaoService() {
	const api = useApi()

	async function getFiltroFundacao(query = '?=') {
		return await api.query(
			`${window.origin}${URLS.cliente_filtro_fundacao}${query}`
		)
	}

	async function getInformacoesFundacao(fundacaoId = '', params = {}) {
		return await api.query(
			`${window.origin}${URLS.informacoes_modal_fundacao}${fundacaoId}`,
			params
		)
	}

	async function getFundacoes(params = {}) {
		return await api.query(`${window.origin}${URLS.api_fundacao}`, params)
	}

	return { getFiltroFundacao, getInformacoesFundacao, getFundacoes, ...api }
}
